<template>
  <div class="atlas-visual-container">
    <div class="atlas-visual-box">
      <div class="atlas-getting-started-visual" aria-label="Travel photo stack with social icons">
        <div class="sparkle" aria-hidden="true"></div>

        <section class="photo-stack" aria-hidden="true">
          <div class="photo-card photo-third">
            <img src="https://cdn.shrpa.com/cms/images/expeditions/thumbnocrop/90f05c3d-ffb7-4522-88f4-8b5df0deeff6.jpg" alt="" />
          </div>
          <div class="photo-card photo-secondary">
            <img src="https://cdn.shrpa.com/cms/images/expeditions/thumbnocrop/ee1697c7-4778-4d91-bb07-41cc31e68605.jpg" alt="" />
          </div>
          <div class="photo-card photo-primary">
            <img src="https://cdn.shrpa.com/cms/images/expeditions/thumbnocrop/cc0ac1fa-e46e-4a63-9b7c-a0103039aebb.jpg" alt="" />
          </div>
        </section>

        <svg class="curved-arrow" viewBox="0 0 270 58" aria-hidden="true">
          <path d="M9 8C67 52 177 57 257 8" />
          <path d="M236 6L258 8L246 28" />
        </svg>

        <aside class="social-icons" aria-label="Social icons">
          <div class="social-icon instagram" aria-label="Instagram">
            <img src="http://shrpa.com/images/social-logo-instagram.svg" alt="" />
          </div>
          <div class="social-icon facebook" aria-label="Facebook">
            <img src="http://shrpa.com/images/social-logo-facebook.svg" alt="" />
          </div>
          <div class="social-icon tiktok" aria-label="TikTok">
            <img src="http://shrpa.com/images/social-logo-tiktok.svg" alt="" />
          </div>
        </aside>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts"></script>

<style scoped lang="scss">
@import "@/scss/screen-size-ranges.scss";

.atlas-visual-container,
.atlas-visual-box,
.atlas-getting-started-visual,
.atlas-getting-started-visual * {
  box-sizing: border-box;
}

.atlas-visual-container {
  container-type: inline-size;
  width: 100%;
  max-width: 541px;
  --atlas-scale: min(1, calc(100cqi / 541px));
}

.atlas-visual-box {
  width: calc(541px * var(--atlas-scale));
  height: calc(328px * var(--atlas-scale));
}

.atlas-getting-started-visual {
  position: relative;
  width: 541px;
  height: 328px;
  overflow: hidden;
  background: #fffefd;
  transform: scale(var(--atlas-scale));
  transform-origin: top left;
}

.photo-stack,
.photo-card,
.social-icons,
.curved-arrow,
.sparkle {
  position: absolute;
}

.photo-stack {
  inset: 0;
}

.photo-card {
  overflow: hidden;
  border: 6px solid #ffffff;
  background: #ececeb;
  box-shadow: 0 8px 18px rgba(24, 38, 43, 0.12);
}

.photo-card img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.photo-primary {
  z-index: 3;
  left: 28px;
  top: 9px;
  width: 209px;
  height: 255px;
  border-radius: 18px;
  transform: rotate(-5.3deg);
  transform-origin: 52% 47%;
}

.photo-primary img {
  object-position: 48% 50%;
}

.photo-secondary {
  z-index: 2;
  opacity: 0.9;
  left: 166px;
  top: 24px;
  width: 160px;
  height: 220px;
  border-radius: 17px;
  transform: rotate(5deg);
  transform-origin: 50% 50%;
}

.photo-secondary img {
  object-position: 50% 50%;
}

.photo-third {
  z-index: 1;
  left: 303px;
  top: 65px;
  width: 66px;
  height: 156px;
  border-radius: 16px;
  opacity: 0.58;
  transform: rotate(8deg);
  transform-origin: 50% 50%;
}

.sparkle {
  left: 345px;
  top: 8px;
  width: 24px;
  height: 24px;
  background: #a9cac9;
  clip-path: polygon(50% 0, 61% 37%, 100% 50%, 61% 63%, 50% 100%, 39% 63%, 0 50%, 39% 37%);
}

.curved-arrow {
  left: 125px;
  top: 269px;
  width: 270px;
  height: 58px;
  fill: none;
  stroke: #9fc4c3;
  stroke-width: 4;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.social-icons {
  top: 8px;
  right: 21px;
  width: 88px;
  display: grid;
  gap: 14px;
}

.social-icon {
  display: grid;
  place-items: center;
  width: 88px;
  height: 88px;
  border: 2px solid #eeeeee;
  border-radius: 50%;
  background: #ffffff;
  box-shadow: 0 1px 3px rgba(33, 33, 33, 0.04);
}

.social-icon img {
  display: block;
  object-fit: contain;
}

.instagram img {
  width: 44px;
  height: 44px;
}

.facebook img {
  width: 47px;
  height: 47px;
}

.tiktok img {
  width: 48px;
  height: 48px;
}
</style>
